import { render } from "./JitsiMeet.vue?vue&type=template&id=329ba39e"
import script from "./JitsiMeet.vue?vue&type=script&lang=js"
export * from "./JitsiMeet.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__